import objectPath from 'object-path'
import { getCurrentUi } from 'designer/component/action/Data'

const getRuleSelectRowTableTargets = (action = {}, target = '') => {
  return [
    target,
    action.target,
    action.targetKey,
    action.key,
    action.valueKey,
    action.targetName,
    action.targetOptionValue,
    action.formDataKey,
  ].filter((key, index, list) => key && list.indexOf(key) === index)
}

const getRuleSelectRowTableUi = (
  designContext = {},
  action = {},
  target = '',
) => {
  let { jsonForm = {} } = designContext
  let targets = getRuleSelectRowTableTargets(action, target)

  for (let targetKey of targets) {
    let ui = getCurrentUi(targetKey, jsonForm.schema, jsonForm.uischema)
    if (ui.key === targetKey) return ui
  }

  return {}
}

const getRuleSelectRowTableData = (formData = {}, uischema = {}) => {
  let tableData =
    (uischema.name ? objectPath.get(formData, uischema.name) : undefined) ||
    (uischema.key ? objectPath.get(formData, uischema.key) : undefined) ||
    []

  return Array.isArray(tableData) ? tableData : []
}

const getRuleSelectRowTableRefId = (formData = {}, action = {}) => {
  let fieldMapColumnRefId = action.fieldMapColumnRefId || {}
  let fieldMapColumnRefName = fieldMapColumnRefId.valueKey
  let fieldMapColumnRefKey =
    fieldMapColumnRefId.key ||
    fieldMapColumnRefId.fieldKey ||
    fieldMapColumnRefId.optionValue

  if (!fieldMapColumnRefKey) return undefined

  return (
    (fieldMapColumnRefName
      ? objectPath.get(formData, fieldMapColumnRefName)
      : undefined) || objectPath.get(formData, fieldMapColumnRefKey)
  )
}

const setRuleSelectRowTableFormData = (
  designContext = {},
  formData = {},
  targetKey,
  rowData = {},
) => {
  let { setFieldFormData, setFormData } = designContext
  let rowSelectedKey = `@rowSelected.${targetKey}`

  objectPath.set(formData, rowSelectedKey, rowData)
  if (setFieldFormData) setFieldFormData(rowSelectedKey, rowData)
  if (setFormData) setFormData(formData)
}

const setRuleSelectRowTableUiChanged = (
  designContext = {},
  targetKey,
  rowData = {},
) => {
  let { isUiChanged = {}, setIsUiChanged } = designContext

  objectPath.set(isUiChanged, targetKey, {
    isRender: true,
    dataRowClicked: rowData,
  })
  if (setIsUiChanged) setIsUiChanged(isUiChanged)
}

const setRuleSelectRowTableAction = (
  designContext = {},
  action = {},
  data = {},
  target = '',
  isSelectRow,
) => {
  let { jsonForm = {} } = designContext
  let formData = data.formData || jsonForm.formData || {}
  let uischema = getRuleSelectRowTableUi(designContext, action, target)
  if (!uischema.key) return undefined

  let rowData = {}

  if (isSelectRow) {
    let tableData = getRuleSelectRowTableData(formData, uischema)
    let columnRefId = uischema?.loadData?.columnRefId
    let fieldRefId = getRuleSelectRowTableRefId(formData, action)

    if (!columnRefId || !fieldRefId) return undefined

    rowData =
      tableData.find(
        (rowItem) => objectPath.get(rowItem, columnRefId) === fieldRefId,
      ) || {}
  }

  setRuleSelectRowTableFormData(
    designContext,
    formData,
    uischema.key,
    rowData,
  )
  setRuleSelectRowTableUiChanged(designContext, uischema.key, rowData)

  return {
    key: uischema.key,
    rowData,
  }
}

export const onRuleSelectRowTable = (
  designContext = {},
  action = {},
  data = {},
  target = '',
) => {
  return setRuleSelectRowTableAction(
    designContext,
    action,
    data,
    target,
    true,
  )
}

export const onRuleUnselectRowTable = (
  designContext = {},
  action = {},
  data = {},
  target = '',
) => {
  return setRuleSelectRowTableAction(
    designContext,
    action,
    data,
    target,
    false,
  )
}
